"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.academyProgressSchema = exports.academyProgressItemSchema = exports.academyLessonIdSchema = void 0;
// J-314 (update 2, item 2c): the wire shape of `GET` and `PUT /api/v1/academy/progress`, as the Academy
// package's contract states it (its README, "Contract with the portal"; oversight's decision D1). The
// user is the session's, never a field of the body. Progress holds no patient data.
const zod_1 = require("zod");
const academy_js_1 = require("./db/academy.js");
exports.academyLessonIdSchema = zod_1.z.enum(academy_js_1.ACADEMY_LESSON_IDS);
exports.academyProgressItemSchema = zod_1.z
    .object({
    lessonId: exports.academyLessonIdSchema,
    /** `<part index>:<scene index>`, both from 0, at most 16 characters; or null. */
    lastScene: zod_1.z
        .string()
        .max(16)
        .regex(/^[0-9]+:[0-9]+$/)
        .nullable(),
    /** ISO 8601, or null while the lesson is not finished. */
    completedAt: zod_1.z.iso.datetime({ offset: true }).nullable(),
})
    .meta({ id: "AcademyProgressItem" });
exports.academyProgressSchema = zod_1.z
    .object({ items: zod_1.z.array(exports.academyProgressItemSchema) })
    .meta({ id: "AcademyProgress" });
//# sourceMappingURL=academy.js.map